import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-500/10' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-500/10' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-500/10' },
};

const cardImages = [
  'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20media%20display%20with%20floating%20screens%20showing%20trending%20content%2C%20warm%20golden%20ambient%20lighting%2C%20minimalist%20gallery%20setting%2C%20sophisticated%20art%20direction%2C%20rich%20textures&width=600&height=400&seq=cat-card-latest&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20film%20projector%20with%20warm%20nostalgic%20lighting%2C%20classic%20cinema%20memorabilia%2C%20retro%20theater%20atmosphere%2C%20soft%20golden%20hour%20glow%2C%20artistic%20still%20life%20composition&width=600&height=400&seq=cat-card-classic&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20Chinese%20home%20theater%20with%20large%204K%20screen%20displaying%20nature%20documentary%2C%20warm%20cozy%20living%20room%20atmosphere%2C%20soft%20ambient%20lighting%2C%20premium%20entertainment%20setup&width=600&height=400&seq=cat-card-hd&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20library%20with%20organized%20media%20collections%20on%20wooden%20shelves%2C%20warm%20reading%20atmosphere%2C%20soft%20natural%20light%20through%20windows%2C%20sophisticated%20interior%20design&width=600&height=400&seq=cat-card-collection&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Premium%20Chinese%20cinema%20premiere%20event%20with%20red%20carpet%20and%20golden%20spotlights%2C%20luxurious%20atmosphere%2C%20exclusive%20vibe%2C%20warm%20dramatic%20lighting%2C%20elegant%20venue&width=600&height=400&seq=cat-card-exclusive&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20Chinese%20community%20review%20board%20with%20golden%20stars%20and%20ratings%2C%20cozy%20cafe%20atmosphere%2C%20soft%20ambient%20lighting%2C%20artistic%20flat%20lay%20composition&width=600&height=400&seq=cat-card-recommended&orientation=landscape',
];

export default function FeaturedCategories() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-primary-600 mb-3">内容分类</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">探索精选内容频道</h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">六大分类频道，覆盖最新热播、经典回顾、高清精选等多元内容，满足您的每一种观看需求</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat, i) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group relative rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={cardImages[i]}
                    alt={cat.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute bottom-3 left-4 right-4 flex items-center gap-2">
                    <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${colors.iconBg}`}>
                      <i className={`${cat.icon} text-base ${colors.text}`}></i>
                    </div>
                    <span className="text-sm font-semibold text-background-50 font-heading">{cat.name}</span>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}